import { DialogProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ModalBasic } from "../../../../../shared/components/ModalBasic";
import { TModalsIds } from "../../../../../app/state/modalSlice/types";
import { useModalSelectors } from "../../../../../app/state/modalSlice/hook/use-modal-selectors";
import styles from "./styles.module.css";
import { useImageViewZoom } from "../../hook/use-image-view-zoom";

interface Props extends Omit<DialogProps, "open"> {
  src: string;
  closeModal: (id: TModalsIds) => void;
}

export const ImageViewModal = ({ closeModal, src, ...rest }: Props) => {
  const imageView = useModalSelectors("image_view_modal");

  const { containerRef, onMouseDown, imageStyle } = useImageViewZoom(
    imageView.isOpen,
  );

  return (
    <ModalBasic
      open={imageView.isOpen}
      hasHeader={false}
      onClose={() => closeModal("image_view_modal")}
      closeModal={() => closeModal("image_view_modal")}
      {...rest}
    >
      <div ref={containerRef} className={styles["modal-image-container"]}>
        <img
          src={src}
          draggable={false}
          onMouseDown={onMouseDown}
          style={imageStyle}
        />
      </div>
    </ModalBasic>
  );
};
